module.exports = __webpack_public_path__ + "static/media/panel-image.e68f806e.jpg";